export interface Agency {
  id: string;
  name: string;
  logo: string;
  brandColor: string;
  ownerName: string;
  ownerEmail: string;
  plan: 'Starter' | 'Professional' | 'Enterprise' | 'Custom';
  status: 'Active' | 'Suspended' | 'Trial' | 'Cancelled';
  country: string;
  city: string;
  staff: number;
  bookingsMTD: number;
  mrr: number;
  joinDate: string;
  lastActive: string;
  timezone: string;
  currency: string;
}

export const mockAgencies: Agency[] = [
  {
    id: 'agency-001',
    name: 'Horizon Travel',
    logo: 'HT',
    brandColor: '#0D9488',
    ownerName: 'Mohammed Khalid',
    ownerEmail: 'mk@horizontravel.ae',
    plan: 'Professional',
    status: 'Active',
    country: 'UAE',
    city: 'Dubai',
    staff: 7,
    bookingsMTD: 347,
    mrr: 899,
    joinDate: 'Jan 2024',
    lastActive: '2 min ago',
    timezone: 'Asia/Dubai',
    currency: 'AED',
  },
  {
    id: 'agency-002',
    name: 'Desert Trails Travel',
    logo: 'DT',
    brandColor: '#D97706',
    ownerName: 'Ahmed Al-Maktoum',
    ownerEmail: 'ahmed@deserttrails.ae',
    plan: 'Enterprise',
    status: 'Active',
    country: 'UAE',
    city: 'Abu Dhabi',
    staff: 18,
    bookingsMTD: 892,
    mrr: 1999,
    joinDate: 'Aug 2023',
    lastActive: '18 min ago',
    timezone: 'Asia/Dubai',
    currency: 'AED',
  },
  {
    id: 'agency-003',
    name: 'Cairo Voyages',
    logo: 'CV',
    brandColor: '#16A34A',
    ownerName: 'Omar Hassan',
    ownerEmail: 'omar@cairovoyages.com',
    plan: 'Starter',
    status: 'Active',
    country: 'Egypt',
    city: 'Cairo',
    staff: 3,
    bookingsMTD: 67,
    mrr: 299,
    joinDate: 'Dec 2025',
    lastActive: '2 hours ago',
    timezone: 'Africa/Cairo',
    currency: 'EGP',
  },
  {
    id: 'agency-004',
    name: 'London Luxe Travel',
    logo: 'LL',
    brandColor: '#0891B2',
    ownerName: 'Emily Watson',
    ownerEmail: 'emily@londonluxe.co.uk',
    plan: 'Enterprise',
    status: 'Active',
    country: 'UK',
    city: 'London',
    staff: 22,
    bookingsMTD: 1124,
    mrr: 1999,
    joinDate: 'Mar 2023',
    lastActive: '1 hour ago',
    timezone: 'Europe/London',
    currency: 'GBP',
  },
  {
    id: 'agency-005',
    name: 'Saudi Horizons',
    logo: 'SH',
    brandColor: '#DC2626',
    ownerName: 'Khalid Al-Rashid',
    ownerEmail: 'khalid@saudihorizons.sa',
    plan: 'Enterprise',
    status: 'Active',
    country: 'Saudi Arabia',
    city: 'Riyadh',
    staff: 14,
    bookingsMTD: 743,
    mrr: 1999,
    joinDate: 'Jun 2023',
    lastActive: '45 min ago',
    timezone: 'Asia/Riyadh',
    currency: 'SAR',
  },
  {
    id: 'agency-006',
    name: 'Maldives Escapes',
    logo: 'ME',
    brandColor: '#0F766E',
    ownerName: 'Ali Ibrahim',
    ownerEmail: 'ali@maldivesescapes.mv',
    plan: 'Starter',
    status: 'Trial',
    country: 'Maldives',
    city: 'Malé',
    staff: 2,
    bookingsMTD: 31,
    mrr: 0,
    joinDate: 'Mar 18, 2026',
    lastActive: '6 hours ago',
    timezone: 'Indian/Maldives',
    currency: 'USD',
  },
  {
    id: 'agency-007',
    name: 'Istanbul Dreams',
    logo: 'ID',
    brandColor: '#E11D48',
    ownerName: 'Mehmet Yilmaz',
    ownerEmail: 'mehmet@istanbuldreams.tr',
    plan: 'Starter',
    status: 'Active',
    country: 'Turkey',
    city: 'Istanbul',
    staff: 5,
    bookingsMTD: 128,
    mrr: 299,
    joinDate: 'Oct 2025',
    lastActive: '3 hours ago',
    timezone: 'Europe/Istanbul',
    currency: 'EUR',
  },
  {
    id: 'agency-008',
    name: 'Paris Elite Tours',
    logo: 'PE',
    brandColor: '#DB2777',
    ownerName: 'Sophie Dubois',
    ownerEmail: 'sophie@pariselite.fr',
    plan: 'Professional',
    status: 'Active',
    country: 'France',
    city: 'Paris',
    staff: 9,
    bookingsMTD: 421,
    mrr: 899,
    joinDate: 'Apr 2024',
    lastActive: '25 min ago',
    timezone: 'Europe/Paris',
    currency: 'EUR',
  },
  {
    id: 'agency-009',
    name: 'Singapore Travels',
    logo: 'ST',
    brandColor: '#059669',
    ownerName: 'Wei Chen',
    ownerEmail: 'wei@singaporetravels.sg',
    plan: 'Professional',
    status: 'Active',
    country: 'Singapore',
    city: 'Singapore',
    staff: 11,
    bookingsMTD: 568,
    mrr: 899,
    joinDate: 'Jul 2024',
    lastActive: '12 min ago',
    timezone: 'Asia/Singapore',
    currency: 'SGD',
  },
  {
    id: 'agency-010',
    name: 'Mumbai Journeys',
    logo: 'MJ',
    brandColor: '#F59E0B',
    ownerName: 'Rajesh Kumar',
    ownerEmail: 'rajesh@mumbaijourneys.in',
    plan: 'Starter',
    status: 'Active',
    country: 'India',
    city: 'Mumbai',
    staff: 4,
    bookingsMTD: 194,
    mrr: 299,
    joinDate: 'Nov 2025',
    lastActive: '1 hour ago',
    timezone: 'Asia/Kolkata',
    currency: 'INR',
  },
  {
    id: 'agency-011',
    name: 'New York Elite',
    logo: 'NY',
    brandColor: '#374151',
    ownerName: 'Michael Johnson',
    ownerEmail: 'michael@nyelite.com',
    plan: 'Enterprise',
    status: 'Active',
    country: 'USA',
    city: 'New York',
    staff: 26,
    bookingsMTD: 1348,
    mrr: 1999,
    joinDate: 'Jan 2023',
    lastActive: '5 min ago',
    timezone: 'America/New_York',
    currency: 'USD',
  },
  {
    id: 'agency-012',
    name: 'Sydney Experiences',
    logo: 'SE',
    brandColor: '#B45309',
    ownerName: 'Emma Thompson',
    ownerEmail: 'emma@sydneyexp.com.au',
    plan: 'Professional',
    status: 'Suspended',
    country: 'Australia',
    city: 'Sydney',
    staff: 8,
    bookingsMTD: 0,
    mrr: 0,
    joinDate: 'Sep 2024',
    lastActive: '3 weeks ago',
    timezone: 'Australia/Sydney',
    currency: 'AUD',
  },
  {
    id: 'agency-013',
    name: 'Tokyo Premium Tours',
    logo: 'TP',
    brandColor: '#DC2626',
    ownerName: 'Yuki Tanaka',
    ownerEmail: 'yuki@tokyopremium.jp',
    plan: 'Enterprise',
    status: 'Active',
    country: 'Japan',
    city: 'Tokyo',
    staff: 19,
    bookingsMTD: 876,
    mrr: 1999,
    joinDate: 'Feb 2023',
    lastActive: '30 min ago',
    timezone: 'Asia/Tokyo',
    currency: 'JPY',
  },
  {
    id: 'agency-014',
    name: 'Cape Town Adventures',
    logo: 'CT',
    brandColor: '#16A34A',
    ownerName: 'David van der Berg',
    ownerEmail: 'david@capetownadv.co.za',
    plan: 'Professional',
    status: 'Active',
    country: 'South Africa',
    city: 'Cape Town',
    staff: 10,
    bookingsMTD: 394,
    mrr: 899,
    joinDate: 'May 2024',
    lastActive: '2 hours ago',
    timezone: 'Africa/Johannesburg',
    currency: 'ZAR',
  },
  {
    id: 'agency-015',
    name: 'Milan Luxury Getaways',
    logo: 'ML',
    brandColor: '#0F766E',
    ownerName: 'Giulia Rossi',
    ownerEmail: 'giulia@milanluxury.it',
    plan: 'Professional',
    status: 'Active',
    country: 'Italy',
    city: 'Milan',
    staff: 12,
    bookingsMTD: 501,
    mrr: 899,
    joinDate: 'Jun 2024',
    lastActive: '1 hour ago',
    timezone: 'Europe/Rome',
    currency: 'EUR',
  },
  {
    id: 'agency-016',
    name: 'Bangkok Bliss Travel',
    logo: 'BB',
    brandColor: '#B45309',
    ownerName: 'Somchai Wongsawat',
    ownerEmail: 'somchai@bangkokbliss.th',
    plan: 'Starter',
    status: 'Active',
    country: 'Thailand',
    city: 'Bangkok',
    staff: 6,
    bookingsMTD: 213,
    mrr: 299,
    joinDate: 'Sep 2025',
    lastActive: '4 hours ago',
    timezone: 'Asia/Bangkok',
    currency: 'THB',
  },
];

export interface PlatformUser {
  id: string;
  name: string;
  email: string;
  role: 'super_admin' | 'owner' | 'agent' | 'finance' | 'viewer';
  agencyId: string;
  agencyName: string;
  status: 'Active' | 'Inactive' | 'Invited';
  lastLogin: string;
  avatar: string;
}

export const mockPlatformUsers: PlatformUser[] = [
  { id: 'u1', name: 'Platform Admin', email: 'admin@travelcrm.com', role: 'super_admin', agencyId: '', agencyName: 'TravelCRM Platform', status: 'Active', lastLogin: '2 min ago', avatar: 'PA' },
  { id: 'u2', name: 'Mohammed Khalid', email: 'mk@horizontravel.ae', role: 'owner', agencyId: 'agency-001', agencyName: 'Horizon Travel', status: 'Active', lastLogin: '2 min ago', avatar: 'MK' },
  { id: 'u3', name: 'Sara Ahmed', email: 'sara@horizontravel.ae', role: 'agent', agencyId: 'agency-001', agencyName: 'Horizon Travel', status: 'Active', lastLogin: '15 min ago', avatar: 'SA' },
  { id: 'u4', name: 'Ahmed Al-Maktoum', email: 'ahmed@deserttrails.ae', role: 'owner', agencyId: 'agency-002', agencyName: 'Desert Trails Travel', status: 'Active', lastLogin: '18 min ago', avatar: 'AA' },
  { id: 'u5', name: 'Fatima Ibrahim', email: 'fatima@deserttrails.ae', role: 'agent', agencyId: 'agency-002', agencyName: 'Desert Trails Travel', status: 'Active', lastLogin: '1 hour ago', avatar: 'FI' },
  { id: 'u6', name: 'Omar Hassan', email: 'omar@cairovoyages.com', role: 'owner', agencyId: 'agency-003', agencyName: 'Cairo Voyages', status: 'Active', lastLogin: '2 hours ago', avatar: 'OH' },
  { id: 'u7', name: 'Emily Watson', email: 'emily@londonluxe.co.uk', role: 'owner', agencyId: 'agency-004', agencyName: 'London Luxe Travel', status: 'Active', lastLogin: '1 hour ago', avatar: 'EW' },
  { id: 'u8', name: 'James Miller', email: 'james@londonluxe.co.uk', role: 'agent', agencyId: 'agency-004', agencyName: 'London Luxe Travel', status: 'Active', lastLogin: '3 hours ago', avatar: 'JM' },
  { id: 'u9', name: 'Khalid Al-Rashid', email: 'khalid@saudihorizons.sa', role: 'owner', agencyId: 'agency-005', agencyName: 'Saudi Horizons', status: 'Active', lastLogin: '45 min ago', avatar: 'KA' },
  { id: 'u10', name: 'Ali Ibrahim', email: 'ali@maldivesescapes.mv', role: 'owner', agencyId: 'agency-006', agencyName: 'Maldives Escapes', status: 'Active', lastLogin: '6 hours ago', avatar: 'AI' },
  { id: 'u11', name: 'Mehmet Yilmaz', email: 'mehmet@istanbuldreams.tr', role: 'owner', agencyId: 'agency-007', agencyName: 'Istanbul Dreams', status: 'Active', lastLogin: '3 hours ago', avatar: 'MY' },
  { id: 'u12', name: 'Sophie Dubois', email: 'sophie@pariselite.fr', role: 'owner', agencyId: 'agency-008', agencyName: 'Paris Elite Tours', status: 'Active', lastLogin: '25 min ago', avatar: 'SD' },
  { id: 'u13', name: 'Wei Chen', email: 'wei@singaporetravels.sg', role: 'owner', agencyId: 'agency-009', agencyName: 'Singapore Travels', status: 'Active', lastLogin: '12 min ago', avatar: 'WC' },
  { id: 'u14', name: 'Rajesh Kumar', email: 'rajesh@mumbaijourneys.in', role: 'owner', agencyId: 'agency-010', agencyName: 'Mumbai Journeys', status: 'Active', lastLogin: '1 hour ago', avatar: 'RK' },
  { id: 'u15', name: 'Michael Johnson', email: 'michael@nyelite.com', role: 'owner', agencyId: 'agency-011', agencyName: 'New York Elite', status: 'Active', lastLogin: '5 min ago', avatar: 'MJ' },
  { id: 'u16', name: 'Emma Thompson', email: 'emma@sydneyexp.com.au', role: 'owner', agencyId: 'agency-012', agencyName: 'Sydney Experiences', status: 'Inactive', lastLogin: '3 weeks ago', avatar: 'ET' },
  { id: 'u17', name: 'Yuki Tanaka', email: 'yuki@tokyopremium.jp', role: 'owner', agencyId: 'agency-013', agencyName: 'Tokyo Premium Tours', status: 'Active', lastLogin: '30 min ago', avatar: 'YT' },
  { id: 'u18', name: 'David van der Berg', email: 'david@capetownadv.co.za', role: 'owner', agencyId: 'agency-014', agencyName: 'Cape Town Adventures', status: 'Active', lastLogin: '2 hours ago', avatar: 'DV' },
  { id: 'u19', name: 'Giulia Rossi', email: 'giulia@milanluxury.it', role: 'owner', agencyId: 'agency-015', agencyName: 'Milan Luxury Getaways', status: 'Active', lastLogin: '1 hour ago', avatar: 'GR' },
  { id: 'u20', name: 'Somchai Wongsawat', email: 'somchai@bangkokbliss.th', role: 'owner', agencyId: 'agency-016', agencyName: 'Bangkok Bliss Travel', status: 'Active', lastLogin: '4 hours ago', avatar: 'SW' },
];

export interface PlanFeature {
  id: string;
  name: string;
  description: string;
  category: 'core' | 'advanced' | 'integrations' | 'support';
}

export const planFeatures: PlanFeature[] = [
  { id: 'f1', name: 'Core CRM', description: 'Leads, Customers, Tasks management', category: 'core' },
  { id: 'f2', name: 'Bookings Management', description: 'Full booking workflow and tracking', category: 'core' },
  { id: 'f3', name: 'Products Catalog', description: 'Manage tours, packages, services', category: 'core' },
  { id: 'f4', name: 'Itinerary Builder', description: 'Day-by-day trip planning', category: 'core' },
  { id: 'f5', name: 'Invoice System', description: 'Generate and track invoices', category: 'core' },
  { id: 'f6', name: 'Vouchers', description: 'Service vouchers for customers', category: 'core' },
  { id: 'f7', name: 'Quote Builder', description: 'Create and send professional quotes', category: 'advanced' },
  { id: 'f8', name: 'Supplier Directory', description: 'Manage hotel, airline, DMC contacts', category: 'advanced' },
  { id: 'f9', name: 'Email Marketing', description: 'Bulk email campaigns and templates', category: 'integrations' },
  { id: 'f10', name: 'WhatsApp Integration', description: 'Send bookings and invoices via WhatsApp', category: 'integrations' },
  { id: 'f11', name: 'Lead Capture Forms', description: 'Embeddable forms for your website', category: 'integrations' },
  { id: 'f12', name: 'AI Chat Assistant', description: 'AI-powered customer support', category: 'advanced' },
  { id: 'f13', name: 'API Access', description: 'RESTful API for custom integrations', category: 'advanced' },
  { id: 'f14', name: 'Custom Domain', description: 'Use your own domain name', category: 'advanced' },
  { id: 'f15', name: 'White-label PDFs', description: 'Fully branded invoices and itineraries', category: 'advanced' },
  { id: 'f16', name: 'Advanced Analytics', description: 'Revenue reports and forecasting', category: 'advanced' },
  { id: 'f17', name: 'Multi-currency Support', description: 'Accept payments in multiple currencies', category: 'advanced' },
  { id: 'f18', name: 'Priority Support', description: 'Email support with 4-hour SLA', category: 'support' },
  { id: 'f19', name: 'Dedicated Account Manager', description: 'Personal onboarding and support', category: 'support' },
  { id: 'f20', name: 'Phone Support 24/7', description: 'Round-the-clock phone assistance', category: 'support' },
];

export interface PricingPlan {
  id: string;
  name: string;
  price: number;
  maxUsers: number;
  maxBookings: number;
  maxStorage: number;
  features: string[];
  isPopular: boolean;
  isCustom: boolean;
  color: string;
}

export const mockPlans: PricingPlan[] = [
  {
    id: 'plan-starter',
    name: 'Starter',
    price: 299,
    maxUsers: 2,
    maxBookings: 100,
    maxStorage: 5,
    features: ['f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f17', 'f18'],
    isPopular: false,
    isCustom: false,
    color: '#16A34A',
  },
  {
    id: 'plan-professional',
    name: 'Professional',
    price: 899,
    maxUsers: 10,
    maxBookings: -1,
    maxStorage: 20,
    features: ['f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9', 'f10', 'f11', 'f12', 'f17', 'f18'],
    isPopular: true,
    isCustom: false,
    color: '#0D9488',
  },
  {
    id: 'plan-enterprise',
    name: 'Enterprise',
    price: 1999,
    maxUsers: -1,
    maxBookings: -1,
    maxStorage: 100,
    features: ['f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9', 'f10', 'f11', 'f12', 'f13', 'f14', 'f15', 'f16', 'f17', 'f18', 'f19', 'f20'],
    isPopular: false,
    isCustom: false,
    color: '#6366F1',
  },
  {
    id: 'plan-custom',
    name: 'Custom',
    price: 0,
    maxUsers: -1,
    maxBookings: -1,
    maxStorage: -1,
    features: [],
    isPopular: false,
    isCustom: true,
    color: '#374151',
  },
];

export interface MRRDataPoint {
  month: string;
  mrr: number;
  agencies: number;
}

export const mrrHistory: MRRDataPoint[] = [
  { month: 'Oct', mrr: 9200, agencies: 10 },
  { month: 'Nov', mrr: 10800, agencies: 12 },
  { month: 'Dec', mrr: 12400, agencies: 13 },
  { month: 'Jan', mrr: 14100, agencies: 14 },
  { month: 'Feb', mrr: 15600, agencies: 15 },
  { month: 'Mar', mrr: 16388, agencies: 16 },
];